/*
  Project: Karmajoga.pl
  Author: Piotr Bajer
 */

import smoothscroll from 'smoothscroll-polyfill';
import objectFit from './polyfills/object-fit';
import fix100vh from './fixes/100vh';
import header from './modules/header';
import headerVideo from './modules/header-video';
import teachers from './modules/teachers';
import map from './modules/map';
import gallery from './modules/gallery';
import calendar from './modules/calendar';
import featured from './modules/featured';
import posts from './modules/posts';

// Polyfills
objectFit();
smoothscroll.polyfill();

// Code
fix100vh();
header();
headerVideo();
teachers();
map();
gallery();
calendar();
featured();
posts();



// WEBPACK FOOTER //
// ./src/scripts/app.js